'use client';

import React, { useEffect } from 'react';
import { Page, useTranslation, useUi } from '@weareconceptstudio/core';

//* Components
import Footer from '../Footer';
import ScrollWrapper from '../ScrollWrapper';
import { usePathname } from 'next/navigation';
import { config } from '@/helpers';

const HighOrderComponent = ({ children }) => {
	const { isMobile } = useUi();
	const pathname = usePathname();
	const { selectedLang } = useTranslation();

	//! Clear scrollPosition
	useEffect(() => {
		const route = pathname.replace(`/${selectedLang}`, '');
		if (route !== config.routes.recipes.path) {
			sessionStorage.setItem('scrollY', 0);
		}
	});

	return !isMobile ? (
		<ScrollWrapper>
			<Page>{children}</Page>
			<Footer />
		</ScrollWrapper>
	) : (
		<>
			<Page>{children}</Page>
			<Footer />
		</>
	);
};

export default HighOrderComponent;
